// component
import Iconify from '../../components/Iconify';
import constants from '../../constants';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    path: constants.routes.LOCATIONS_MANAGEMENT.path,
    roles: constants.routes.LOCATIONS_MANAGEMENT.roleIds,
    titleLocalId: 'sidebar.navItem.locationsManagement.title',
    defaultTitle: 'Locations Management',
    icon: getIcon('fa6-solid:map-location')
  },
  {
    path: constants.routes.ADMIN_RELEASE_NOTES.path,
    roles: constants.routes.ADMIN_RELEASE_NOTES.roleIds,
    titleLocalId: 'sidebar.navItem.adminReleaseNotes.title',
    defaultTitle: 'Release Notes Management',
    icon: getIcon('pixelarticons:notes-plus')
  },
  {
    path: constants.routes.ADMIN_WORKOUTS_REVIEW.path,
    roles: constants.routes.ADMIN_WORKOUTS_REVIEW.roleIds,
    titleLocalId: 'sidebar.navItem.adminWorkoutsReview.title',
    defaultTitle: 'Add or Deny Workouts',
    icon: getIcon('fluent-mdl2:decision-solid')
  },
  {
    path: constants.routes.WORKOUTS_MANAGEMENT.path,
    roles: constants.routes.WORKOUTS_MANAGEMENT.roleIds,
    titleLocalId: 'sidebar.navItem.workoutsManagement.title',
    defaultTitle: 'Workout Management',
    icon: getIcon('arcticons:my-workout-plan')
  },
  {
    path: constants.routes.CUSTOM_TRAININGS.path,
    roles: constants.routes.CUSTOM_TRAININGS.roleIds,
    titleLocalId: 'sidebar.navItem.customTrainings.title',
    defaultTitle: 'Custom training',
    icon: getIcon('mdi:weight-lifter')
  },
  {
    path: constants.routes.PERSONAL_TRAININGS.path,
    roles: constants.routes.PERSONAL_TRAININGS.roleIds,
    titleLocalId: 'sidebar.navItem.personalTraining.title',
    defaultTitle: 'Personal Trainings',
    icon: getIcon('mdi:account-check'),
  },
  {
    path: constants.routes.GROUP_TRAININGS.path,
    roles: constants.routes.GROUP_TRAININGS.roleIds,
    titleLocalId: 'sidebar.navItem.trainings.title',
    defaultTitle: 'All Trainings',
    icon: getIcon('typcn:group'),
  },
  {
    path: constants.routes.USERS.path,
    roles: constants.routes.USERS.roleIds,
    titleLocalId: 'sidebar.navItem.users.title',
    defaultTitle: 'Users',
    icon: getIcon('clarity:users-line')
  },
  {
    path: constants.routes.USERS_RESERVATION.path,
    roles: constants.routes.USERS_RESERVATION.roleIds,
    titleLocalId: 'sidebar.navItem.usersReservation.title',
    defaultTitle: 'Users Reservation',
    icon: getIcon('fluent-mdl2:reservation-orders')
  },
  {
    path: constants.routes.TRAINING_SESSION.path,
    roles: constants.routes.TRAINING_SESSION.roleIds,
    titleLocalId: 'sidebar.navItem.trainingSession.title',
    defaultTitle: 'Training session',
    icon: getIcon('oui:training')
  },
  {
    path: constants.routes.MODERATOR_USERS_STATISTICS.path,
    roles: constants.routes.MODERATOR_USERS_STATISTICS.roleIds,
    titleLocalId: 'sidebar.navItem.moderatorUsersStatistics.title',
    defaultTitle: 'Moderator Statistics',
    icon: getIcon('bi:pie-chart')
  },
  {
    path: constants.routes.USER_STATISTICS.path,
    roles: constants.routes.USER_STATISTICS.roleIds,
    titleLocalId: 'sidebar.navItem.UserStatistics.title',
    defaultTitle: 'Statistics',
    icon: getIcon('mdi:chart-line')
  }
];

export default sidebarConfig;
